export class MenuNavBase {
    constructor() {
        this.activeListeners = [];
    }

    /**
     * 'addListener' Method to centralize and register 'addEventListener' calls 
     */
    addListener(target, evt, fn, opts = {}) {
        if (target && target.addEventListener) {
            target.addEventListener(evt, fn, opts);
            this.activeListeners.push({
                target,
                evt,
                fn,
                opts
            })
        }
    }

    /**
     * 'removeListeners' Method to remove all listeners attached to this instance.
     */
     removeListeners() {
        this.activeListeners = this.activeListeners.map(listener => {
            if (listener.target && listener.target.removeEventListener) {
                listener.target.removeEventListener(listener.evt, listener.fn, listener.opts);
                return null;
            }
        }).filter(Boolean);
    }
}